import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getContact, updateContact } from "../../store/slice/contactSlice";
import { SidebarComponent } from "../../helpers/commonFunction";

const DeleteContactModal = ({
  handleClose,
  values,
  setValues,
  page_number,
}) => {
  const showHideClassName =
    values?.deleteContactModal && "user_detail_modal_show";

  const { t } = useTranslation("common");

  const dispatch = useDispatch();
  const sideHeading = localStorage.getItem("sidebar_component");

  const deleteRoleHandler = () => {
    const data = { delete_status: "1" };
    dispatch(
      updateContact({
        data,
        id: values.deleteContactData.id,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(
              getContact({
                start: (page_number - 1) * 10,
                search_data: values.search_data,
              })
            );
            setValues({
              ...values,
              deleteContactModal: false,
              deleteContactData: "",
            });
          }
        },
        toast: t("toast.delete_contact"),
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            Delete {SidebarComponent()}
            {/* {sideHeading} */}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.deleteContactDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deleteRoleHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteContactModal;
